// Default imports
import bannerImg from '@assets/images/home/banner/banner.webp';
import bannerCom2 from '@assets/images/home/banner/com2/banner_com2.png';
import bannerNgu3 from '@assets/images/home/banner/ngu3/banner_ngu3.png';
import boxImg from '@assets/images/home/box_1.webp';
import bannerBg from '@assets/images/home/home_quests_banner_bg.png';
import promoImg from '@assets/images/home/home_quests_banner_img.webp';
import prefooterBgCom2 from '@assets/images/home/prefooter/com2/prefooter_bg_com2.png';
import prefooterCom2 from '@assets/images/home/prefooter/com2/prefooter_com2.png';
import prefooterNgu3 from '@assets/images/home/prefooter/ngu3/prefooter_ngu3.png';
import prefooterBg from '@assets/images/home/prefooter_bg.png';
import prefooterImg from '@assets/images/home/prefooter_img.webp';
// Brand-specific imports - ngu3
import bannerBgCom2 from '@assets/images/home/promo/com2/home_quests_banner_bg.png';
import bannerBgCom2En from '@assets/images/home/promo/com2/home_quests_banner_bg_en.webp';
import bannerBgCom2Mob from '@assets/images/home/promo/com2/home_quests_banner_bg_mob.png';
import bannerBgCom2Ru from '@assets/images/home/promo/com2/home_quests_banner_bg_ru.webp';
import promoCom2 from '@assets/images/home/promo/com2/promo_com2.png';
import promoNgu3 from '@assets/images/home/promo/ngu3/promo_ngu3.png';
import promoBannerBg from '@assets/images/home/promo_banner_bg.png';
import promoBannerBgCom2 from '@assets/images/home/promo_group/com2/promo_banner_bg.png';
import promoBannerBgCom2En from '@assets/images/home/promo_group/com2/promo_banner_bg_en.webp';
import promoBannerBgCom2Mob from '@assets/images/home/promo_group/com2/promo_banner_bg_mob.png';
import promoBannerBgCom2Ru from '@assets/images/home/promo_group/com2/promo_banner_bg_ru.webp';
import boxCom2 from '@assets/images/home/promo_group/com2/promo_group_com2.png';
import boxNgu3 from '@assets/images/home/promo_group/ngu3/promo_group_ngu3.png';

import { config } from '@/config.ts';

// Brand-specific imports - com2

type ImageType =
	| 'banner'
	| 'promo'
	| 'box'
	| 'prefooter'
	| 'bannerBg'
	| 'bannerBgEn'
	| 'bannerBgRu'
	| 'bannerBgMob'
	| 'promoBannerBg'
	| 'promoBannerBgEn'
	| 'promoBannerBgRu'
	| 'promoBannerBgMob'
	| 'prefooterBg'
	| 'prefooterBgMob';

interface BrandImageMap {
	[brand: string]: {
		[key in ImageType]?: string;
	};
}

const brandImageMap: BrandImageMap = {
	default: {
		banner: bannerImg,
		promo: promoImg,
		box: boxImg,
		prefooter: prefooterImg,
		bannerBg: bannerBg,
		promoBannerBg: promoBannerBg,
		prefooterBg: prefooterBg
	},
	ngu3: {
		banner: bannerNgu3,
		promo: promoNgu3,
		box: boxNgu3,
		prefooter: prefooterNgu3
	},
	com2: {
		banner: bannerCom2,
		promo: promoCom2,
		box: boxCom2,
		prefooter: prefooterCom2,
		bannerBg: bannerBgCom2,
		bannerBgEn: bannerBgCom2En,
		bannerBgRu: bannerBgCom2Ru,
		bannerBgMob: bannerBgCom2Mob,
		promoBannerBg: promoBannerBgCom2,
		promoBannerBgEn: promoBannerBgCom2En,
		promoBannerBgRu: promoBannerBgCom2Ru,
		promoBannerBgMob: promoBannerBgCom2Mob,
		prefooterBg: prefooterBgCom2
	}
	// Add more brands here as needed
	// rockets: {
	//   banner: bannerRockets,
	//   promo: promoRockets,
	//   box: boxRockets,
	//   prefooter: prefooterRockets
	// }
};

export const getBrandImage = (imageType: ImageType): string => {
	const brand = config.BRAND || 'default';
	const brandImages = brandImageMap[brand] || brandImageMap.default;

	// Return brand-specific image or fallback to default
	return brandImages[imageType] || brandImageMap.default[imageType] || '';
};
